// Static content for the "Zwiększ liczbę castingów w UK / Get More Auditions
// in the UK" paid Career Path template. NO runtime LLM calls, NO web fetches.
// Any change to copy must be edited in this file only.

export const GET_MORE_AUDITIONS_TEMPLATE = {
  pl: {
    back: "Wróć",
    eyebrow: "Ścieżka kariery",
    title: "Zwiększ liczbę castingów w UK",
    stepLabel: "Krok",
    intro:
      "Masz wrażenie, że powinieneś dostawać więcej castingów w UK, ale nie wiesz, co właściwie Cię blokuje?\n\nNa liczbę castingów wpływa wiele rzeczy, których aktor nie kontroluje. Są jednak również elementy, na które masz realny wpływ.\n\nTa ścieżka pomoże Ci spojrzeć strategicznie na swoją sytuację na brytyjskim rynku i sprawdzić, co może ograniczać Twoje szanse na właściwe castingi oraz gdzie masz największą przestrzeń do poprawy.\n\nPrzejdziesz przez proces, który pomoże Ci lepiej wykorzystać swoje materiały, pozycjonowanie castingowe, reprezentację, zgłoszenia i kontakty zawodowe.\n\nNie chodzi o wysyłanie się do wszystkiego. Chodzi o zwiększenie prawdopodobieństwa, że właściwy casting director znajdzie właśnie Ciebie.",
    savingLabel: "zapisuję…",
    yourAnswerPlaceholder: "Twoja odpowiedź…",
    step1RatesLabel: "Twoje wskaźniki (obliczane automatycznie)",
    ratesUnknown: "—",
    auditionRateLabel: "Odsetek zgłoszeń zakończonych castingiem",
    callbackRateLabel: "Odsetek castingów zakończonych ponownym zaproszeniem",
    bookingRateLabel: "Odsetek castingów zakończonych zdobyciem roli",
    totalSubmissionsLabel: "Łączna liczba zgłoszeń (auto)",
    addContactToCrm: "Dodaj kontakt do CRM",
    steps: [
      {
        // 01
        title: "Sprawdź, gdzie naprawdę jest problem",
        body:
          "Sprawdź swoje wyniki z ostatnich 3 miesięcy.\nŁączna liczba zgłoszeń liczona jest automatycznie jako Zgłoszenia przez agenta + Samodzielne zgłoszenia.\nOdsetek zgłoszeń zakończonych castingiem, odsetek castingów zakończonych ponownym zaproszeniem i odsetek castingów zakończonych zdobyciem roli liczą się automatycznie na podstawie wpisanych liczb.",
        numericFields: [
          { key: "agent_submissions", label: "Zgłoszenia przez agenta" },
          { key: "self_submissions", label: "Samodzielne zgłoszenia" },
          { key: "auditions", label: "Castingi / prośby o self-tape" },
          { key: "callbacks", label: "Ponowne zaproszenia / recalle" },
          { key: "bookings", label: "Zdobyte role" },
        ],
        guidance: [
          "Mało zgłoszeń → problemem może być dostęp do okazji lub strategia zgłoszeń.",
          "Dużo zgłoszeń + mało castingów → sprawdź castability, targeting, Spotlight, headshoty i showreel.",
          "Castingi są, ale prawie nie ma ponownych zaproszeń → przyjrzyj się technice castingowej i self-tape.",
          "Ponowne zaproszenia są, zdobytych ról mało → nie zakładaj automatycznie, że problemem jest Twoja gra. Na finalną decyzję wpływa wiele czynników poza kontrolą aktora.",
        ],
        effect: "Efekt: wiesz, który fragment swojego castingowego lejka powinieneś poprawić.",
      },
      {
        // 02
        title: "Określ swoją castability na rynku UK",
        body: "",
        fields: [
          { key: "screen_age", label: "Screen / playing age", hint: "Jaki wiek rzeczywiście grasz?" },
          { key: "casting_type", label: "Casting type", hint: "Do jakich ról jesteś obecnie naturalnie obsadzany?" },
          { key: "appearance", label: "Appearance / heritage" },
          { key: "nationality", label: "Nationality" },
          { key: "native_language", label: "Native language" },
          { key: "languages", label: "Languages" },
          { key: "accents", label: "Accents" },
          { key: "location", label: "Location / bases" },
          { key: "skills", label: "Skills" },
          { key: "strongest_credits", label: "Najmocniejsze credits" },
          { key: "castable_today", label: "Do jakich ról pasuję dziś castingowo?" },
          { key: "castable_wanted", label: "Do jakich ról chcę częściej dostawać castingi?" },
        ],
        after:
          "Casting professionals w UK mogą wyszukiwać aktorów m.in. według playing age, wyglądu, narodowości, języków, akcentów, skills i lokalizacji. Nie próbuj pasować do każdej roli. Zadbaj o to, żeby łatwo było znaleźć Cię do ról, do których naprawdę pasujesz.",
      },
      {
        // 03
        title: "Sprawdź, czy casting director może Cię znaleźć na Spotlight",
        body: "",
        checklist: [
          "Playing age — aktualny i realistyczny",
          "Nationality — poprawna",
          "Appearance — uzupełnione",
          "Native language / languages — wszystko wpisane",
          "Accents — aktualne i uczciwie ocenione",
          "Skills — wpisane wszystkie rzeczywiście posiadane i istotne castingowo",
          "Location / bases — prawidłowe",
          "Credits — wpisane w sekcji Credits",
          "Nazwiska reżyserów, produkcji i firm — bez literówek",
        ],
        after:
          "Nie wpisuj skills ani akcentów, których w rzeczywistości nie posiadasz. Jeśli casting znajdzie Cię dzięki konkretnemu skillowi, powinieneś rzeczywiście umieć go wykonać.",
      },
      {
        // 04
        title: "Zrób audyt pierwszego wrażenia",
        body: "",
        subsections: [
          {
            heading: "Headshoty",
            body:
              "Sprawdź:\n• czy wyglądasz obecnie jak na zdjęciach,\n• czy główny headshot jest czytelny jako mały thumbnail,\n• czy masz zdjęcie pokazujące Cię w typie ról, do których jesteś obecnie obsadzany,\n• czy masz zdjęcie bliższe rolom, które chcesz grać,\n• czy zdjęcia pokazują użyteczne castingowo warianty, a nie kilka niemal identycznych fotografii.",
          },
          {
            heading: "Showreel",
            body:
              "Najmocniejszy materiał umieść na początku. Nie zakładaj, że casting director obejrzy cały showreel.\n\nSprawdź pierwsze 30 sekund:\n• czy szybko widać Ciebie,\n• czy szybko słychać Ciebie,\n• czy od razu widać Twoją grę,\n• czy materiał reprezentuje Twój obecny poziom.\n\nJeśli jesteś aktorem międzynarodowym, dobrze mieć materiał po angielsku oraz materiał pokazujący Twój język ojczysty, jeśli jest to istotna część Twojego profilu castingowego.",
          },
        ],
      },
      {
        // 05
        title: "Zwiększ liczbę trafnych zgłoszeń",
        body:
          "Celem nie jest wysyłanie się do wszystkiego. Celem jest nie przegapiać ról, do których naprawdę pasujesz.\n\nRegularnie sprawdzaj odpowiednie breakdowny i przed zgłoszeniem upewnij się:\n• czy pasujesz do playing age,\n• czy spełniasz wymagania językowe i akcentowe,\n• czy masz wymagane skills,\n• czy jesteś dostępny,\n• czy możesz legalnie wykonać pracę,\n• czy lokalizacja jest realna,\n• czy rzeczywiście odpowiadasz briefowi.\n\nWięcej trafnych zgłoszeń, nie więcej spamu.",
      },
      {
        // 06
        title: "Zwiększ skuteczność każdego zgłoszenia",
        body:
          "Dobieraj headshot do konkretnej roli. Nie używaj automatycznie tego samego zdjęcia przy każdym zgłoszeniu.\nJeśli submission note może przekazać castingowi ważną informację, wykorzystaj ją strategicznie.\n\nPrzykłady:\n• Native Polish. Fluent English. Based in London/Warsaw.\n• Native Polish speaker — relevant Polish-language clip on profile.\n\nNie pisz długiego listu. Najważniejsza informacja powinna pojawić się od razu.\n\nSubmission note ma odpowiadać na pytanie:\nDlaczego spełniam konkretny wymóg tej roli?\n\nJeśli nie wnosi nic wartościowego, nie dodawaj jej na siłę.",
      },
      {
        // 07
        title: "Jeśli masz agenta, sprawdź strategię zgłoszeń",
        body:
          "Jeśli masz agenta i liczba castingów jest niska, porozmawiaj z nim profesjonalnie o strategii.\n\nZapytaj:\n• Jak obecnie widzisz mnie castingowo?\n• Do jakich typów ról mnie zgłaszasz?\n• Czy są role, do których powinienem być częściej proponowany?\n• Czy moje headshoty odpowiadają temu, jak mnie sprzedajesz?\n• Czy showreel pomaga, czy mnie ogranicza?\n• Czy brakuje materiału pokazującego konkretny typ, język albo akcent?\n• Czy są obszary rynku, których obecnie nie wykorzystujemy?\n\nNie pytaj: „Dlaczego nie załatwiasz mi castingów?\"\nZapytaj raczej: „Co możemy zrobić, żeby zwiększyć moje szanse na właściwe castingi?\"",
      },
      {
        // 08
        title: "Poszerz źródła, z których mogą przychodzić castingi",
        body: "",
        checklist: [
          "Zgłoszenia przez agenta",
          "Samodzielne zgłoszenia na Spotlight",
          "Wyszukiwania casting directors na Spotlight",
          "Casting directors, którzy już mnie znają",
          "Reżyserzy, z którymi pracowałem",
          "Producenci, z którymi pracowałem",
          "Poprzednie produkcje",
          "Warsztaty branżowe",
          "Networking zawodowy",
          "Projekty międzynarodowe",
        ],
        after:
          "Kto już mnie zna? Zastanów się nad:\n• casting directorzy, którzy Cię castingowali,\n• reżyserami, z którymi pracowałeś,\n• producentami,\n• ludźmi z poprzednich produkcji,\n• osobami poznanymi zawodowo.\n\nWażne kontakty zapisuj w CRM LEO. Dzięki temu możesz budować swoją sieć zawodową i wracać do właściwych osób wtedy, kiedy masz realny powód do kontaktu.",
        crmLink: true,
      },
      {
        // 09
        title: "Spraw, żeby dobry casting prowadził do kolejnych",
        body:
          "Celem castingu jest nie tylko zdobycie tej jednej roli. Dobry casting może sprawić, że casting director zapamięta Cię i zaprosi ponownie do innego projektu.\n\nDlatego:\n• przeczytaj dokładnie instrukcje,\n• przygotuj tekst,\n• podejmij konkretne wybory aktorskie,\n• nie komplikuj technicznie self-tape'a,\n• wyślij właściwe pliki,\n• dotrzymaj deadline'u,\n• zachowuj profesjonalizm również wtedy, kiedy nie dostajesz roli.\n\nNie próbuj rozpaczliwie zgadywać, czego casting director chce. W ramach briefu pokaż swoją interpretację roli.",
      },
      {
        // 10
        title: "Po 30 dniach sprawdź, czy coś się zmieniło",
        body:
          "Po 30 dniach wróć do danych zapisanych w Kroku 1 i porównaj:\n• zgłoszenia,\n• castingi,\n• ponowne zaproszenia,\n• zdobyte role,\n• odsetek zgłoszeń zakończonych castingiem.\n\nZadaj sobie pytania:\n• Czy liczba trafnych zgłoszeń wzrosła?\n• Czy większy procent zgłoszeń prowadzi do castingów?\n• Czy więcej castingów prowadzi do ponownych zaproszeń?\n• Który fragment lejka nadal jest najsłabszy?\n\nNa tej podstawie zdecyduj, nad czym pracować w kolejnym miesiącu.",
      },
    ],
    // Text used on the paywall/preview
    preview: {
      cta_title: "Zwiększ swoje szanse na więcej castingów",
      cta_sub: "Odblokuj pełną ścieżkę i zacznij działać krok po kroku.",
      preview_label: "Podgląd Kroku 01",
      hard_cut_note: "Dalsza część Kroku 01 oraz Kroki 02–10 są dostępne w płatnym planie.",
    },
  },
  en: {
    back: "Back",
    eyebrow: "Career Path",
    title: "Get More Auditions in the UK",
    stepLabel: "Step",
    intro:
      "Feel like you should be getting more auditions in the UK, but you're not sure what's holding you back?\n\nMany factors affecting the number of auditions you receive are outside an actor's control. But there are also important things you can influence.\n\nThis Career Path will help you take a strategic look at your position in the UK market, identify what may be limiting your chances of getting the right auditions, and understand where you have the greatest room for improvement.\n\nYou'll go through a process designed to help you make better use of your materials, casting positioning, representation, submissions and professional relationships.\n\nThe goal isn't to submit yourself for everything. It's to increase the chances that the right casting director finds you for the right role.",
    savingLabel: "saving…",
    yourAnswerPlaceholder: "Your answer…",
    step1RatesLabel: "Your rates (calculated automatically)",
    ratesUnknown: "—",
    auditionRateLabel: "Audition rate",
    callbackRateLabel: "Callback rate",
    bookingRateLabel: "Booking rate",
    totalSubmissionsLabel: "Total submissions (auto)",
    addContactToCrm: "Add contact to CRM",
    steps: [
      {
        // 01
        title: "Find out where the real problem is",
        body:
          "Review your results from the last 3 months.\nTotal submissions are calculated automatically as Agent submissions + Self-submissions.\nAudition rate, callback rate and booking rate are calculated automatically based on the numbers you enter.",
        numericFields: [
          { key: "agent_submissions", label: "Agent submissions" },
          { key: "self_submissions", label: "Self-submissions" },
          { key: "auditions", label: "Auditions / self-tape requests" },
          { key: "callbacks", label: "Callbacks / recalls" },
          { key: "bookings", label: "Bookings" },
        ],
        guidance: [
          "Low number of submissions → the issue may be access to opportunities or your submission strategy.",
          "Many submissions + very few auditions → review your castability, targeting, Spotlight profile, headshots and showreel.",
          "You get auditions but very few callbacks → look more closely at your audition and self-tape technique.",
          "You get callbacks but few bookings → don't automatically assume your acting is the problem. Final casting decisions depend on many factors outside an actor's control.",
        ],
        effect: "Outcome: you know which part of your casting funnel needs attention.",
      },
      {
        // 02
        title: "Define your castability in the UK market",
        body: "",
        fields: [
          { key: "screen_age", label: "Screen / playing age", hint: "What age range do you genuinely play?" },
          { key: "casting_type", label: "Casting type", hint: "What kinds of roles are you naturally cast in now?" },
          { key: "appearance", label: "Appearance / heritage" },
          { key: "nationality", label: "Nationality" },
          { key: "native_language", label: "Native language" },
          { key: "languages", label: "Languages" },
          { key: "accents", label: "Accents" },
          { key: "location", label: "Location / bases" },
          { key: "skills", label: "Skills" },
          { key: "strongest_credits", label: "Strongest credits" },
          { key: "castable_today", label: "What roles am I realistically castable for today?" },
          { key: "castable_wanted", label: "What roles do I want to be cast in more often?" },
        ],
        after:
          "Casting professionals in the UK can search for performers using criteria such as playing age, appearance, nationality, languages, accents, skills and location. Don't try to be right for every role. Make it easy to find you for the roles you genuinely fit.",
      },
      {
        // 03
        title: "Check whether casting directors can find you on Spotlight",
        body: "",
        checklist: [
          "Playing age — current and realistic",
          "Nationality — correct",
          "Appearance — completed",
          "Native language / languages — complete",
          "Accents — current and honestly rated",
          "Skills — all genuine casting-relevant skills included",
          "Location / bases — correct",
          "Credits — entered in the Credits section",
          "Director, production and company names — no spelling mistakes",
        ],
        after:
          "Don't list skills or accents you can't genuinely perform. If a casting director finds and shortlists you because of a particular skill, you should actually be able to deliver it.",
      },
      {
        // 04
        title: "Audit your first impression",
        body: "",
        subsections: [
          {
            heading: "Headshots",
            body:
              "Check:\n• whether you currently look like your photographs,\n• whether your main headshot works as a small thumbnail,\n• whether you have an image reflecting the roles you're currently cast in,\n• whether you have an image closer to the roles you want to play,\n• whether your images provide useful casting variation rather than several nearly identical photographs.",
          },
          {
            heading: "Showreel",
            body:
              "Put your strongest material first. Don't assume a casting director will watch the whole reel.\n\nReview the first 30 seconds:\n• do we see you quickly,\n• do we hear you quickly,\n• does your acting appear immediately,\n• does the material represent your current level?\n\nIf you're an international actor, consider having material in English as well as material demonstrating your native language when that is relevant to your casting profile.",
          },
        ],
      },
      {
        // 05
        title: "Increase the number of relevant submissions",
        body:
          "The goal isn't to submit for everything. The goal is not to miss roles you're genuinely right for.\n\nCheck relevant breakdowns regularly and before submitting ask:\n• do I fit the playing age,\n• do I meet the language/accent requirements,\n• do I have the required skills,\n• am I available,\n• can I legally perform the work,\n• is the location realistic,\n• do I genuinely fit the brief?\n\nMore relevant submissions, not more spam.",
      },
      {
        // 06
        title: "Make each submission more effective",
        body:
          "Match the headshot to the specific role. Don't automatically use the same image for every submission.\nIf a submission note can communicate something genuinely relevant, use it strategically.\n\nExamples:\n• Native Polish. Fluent English. Based in London/Warsaw.\n• Native Polish speaker — relevant Polish-language clip on profile.\n\nDon't write a long cover letter. Put the most useful information first.\n\nYour submission note should answer:\nWhy do I meet a specific requirement of this role?\n\nIf the note adds nothing useful, don't force one.",
      },
      {
        // 07
        title: "If you have an agent, review your submission strategy",
        body:
          "If you have an agent and you're receiving few auditions, have a professional conversation about strategy.\n\nAsk:\n• How do you currently see me casting-wise?\n• What types of roles are you submitting me for?\n• Are there roles I should be submitted for more often?\n• Do my headshots support the way you're pitching me?\n• Is my showreel helping or limiting me?\n• Am I missing material showing a particular type, language or accent?\n• Are there areas of the market we're currently not using?\n\nDon't ask: \"Why aren't you getting me auditions?\"\nAsk instead: \"What can we do to increase my chances of getting the right auditions?\"",
      },
      {
        // 08
        title: "Expand the sources your auditions can come from",
        body: "",
        checklist: [
          "Agent submissions",
          "Spotlight self-submissions",
          "Casting director searches on Spotlight",
          "Casting directors who already know me",
          "Directors I've worked with",
          "Producers I've worked with",
          "Previous productions",
          "Industry workshops",
          "Professional networking",
          "International projects",
        ],
        after:
          "Who already knows me? Think about:\n• casting directors you've auditioned for,\n• directors you've worked with,\n• producers,\n• people from previous productions,\n• people you've met professionally.\n\nSave important professional contacts in LEO CRM. This allows you to build your network and reconnect with the right people when you have a genuine reason to do so.",
        crmLink: true,
      },
      {
        // 09
        title: "Make a good audition lead to future auditions",
        body:
          "An audition isn't only about booking that one role. A strong audition can make a casting director remember you and invite you back for another project.\n\nTherefore:\n• read the instructions carefully,\n• prepare the text,\n• make clear acting choices,\n• don't overcomplicate the self-tape technically,\n• send the correct files,\n• meet the deadline,\n• remain professional even when you don't book the role.\n\nDon't desperately try to guess exactly what the casting director wants. Work within the brief and bring your own interpretation to the role.",
      },
      {
        // 10
        title: "Review what changed after 30 days",
        body:
          "After 30 days, return to the numbers saved in Step 1 and compare:\n• submissions,\n• auditions,\n• callbacks,\n• bookings,\n• audition rate.\n\nAsk:\n• Did the number of relevant submissions increase?\n• Are more of my submissions leading to auditions?\n• Are more auditions leading to callbacks?\n• Which part of the funnel is still weakest?\n\nUse this to decide what to focus on during the next month.",
      },
    ],
    preview: {
      cta_title: "Increase Your Chances of Getting More Auditions",
      cta_sub: "Unlock the full Career Path and start taking action step by step.",
      preview_label: "Step 01 preview",
      hard_cut_note: "The rest of Step 01 and Steps 02–10 are available on a paid plan.",
    },
  },
};
